import { BaseModal } from "./Modal";
import { ModalNames, State, StateProps } from "../state";
import RecipeEditorModal from "./RecipeEditorModal";
import { SettingsModal } from "./SettingsModal";
import { RecipeBookModal } from "./RecipeBookModal";
import { RecipeCardModal } from "./RecipeCardModal";
import { ConfirmationModal } from "./ConfirmationModal";

const modalMap = {
  [ModalNames.NEW_RECIPE]: RecipeEditorModal,
  [ModalNames.RECIPE_BOOK]: RecipeBookModal,
  [ModalNames.RECIPE_CARD]: RecipeCardModal,
  [ModalNames.SETTINGS]: SettingsModal,
  [ModalNames.CONFIRMATION]: ConfirmationModal,
};
export interface ModalsProps extends StateProps {
  readonly setSaveRecipeSnackbarOpen?: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  readonly setSaveRecipeSnackbarText?: React.Dispatch<
    React.SetStateAction<string>
  >;
}
export function Modals(props: ModalsProps) {
  const { state, setState } = props;
  return Object.values(ModalNames).map((name, idx) => {
    return BaseModal({
      state,
      setState,
      component: modalMap[name]({ ...props }),
      name,
      id: `${idx}-${name}`,
    });
  });
}
